import React from 'react'
import './rating.css'
const Rating = (props) => {
  const avgRating = (props?.reviews.reduce((total, item) => (total + item.rating), 0)/props?.reviews.length).toFixed(1);
  return (
    <div className='rating-container'>
        <div className='rating-box'>
            <div className='rating-point'>{avgRating} <i className="fa-solid fa-star"></i></div>
            {props?.reviewlink?(<a href="#reviews-scroll" className="reviews"><div className='ratings'>{props?.totCount} Ratings</div></a>):(<div className='ratings'>{props?.totCount} Ratings</div>)}
        </div>
    </div>
  )
}

export default Rating
